export default "__VITE_ASSET__DJRFkzuC__"